import { useEffect, useState } from 'react'
import * as XLSX from 'xlsx'

/** Renders every sheet of an .xlsx as HTML tables (read-only preview). Fetches through the signed URL. */
export default function ExcelPreview({ url }: { url: string }) {
  const [sheets, setSheets] = useState<{ name: string; html: string }[]>([])
  const [active, setActive] = useState(0)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let alive = true
    setSheets([])
    setError(null)
    fetch(url)
      .then((r) => r.arrayBuffer())
      .then((buf) => {
        const wb = XLSX.read(buf, { type: 'array', cellStyles: false })
        const list = wb.SheetNames.map((name) => ({ name, html: XLSX.utils.sheet_to_html(wb.Sheets[name], { editable: false }) }))
        if (alive) setSheets(list)
      })
      .catch((e) => alive && setError(e instanceof Error ? e.message : String(e)))
    return () => {
      alive = false
    }
  }, [url])

  if (error) return <p className="error">{error}</p>
  if (sheets.length === 0) return <p className="muted">…</p>
  return (
    <div className="stack">
      <div className="tabs">
        {sheets.map((s, i) => <button key={s.name} className={i === active ? 'active' : ''} onClick={() => setActive(i)}>{s.name}</button>)}
      </div>
      <div className="excel-preview table-wrap" dangerouslySetInnerHTML={{ __html: sheets[active].html }} />
    </div>
  )
}
